<template>
  <modal
    class="reservationDetailModal"
    :title="
      'Rezervasyon' + (reservation && reservation.Id ? ' #' + reservation.Id : '')
    "
    :size="'xl'"
    @close="close"
  >
    <template #content>
      <div class="kr-modal-body">
      <!-- Tekrar gösterme yapilmis rezervasyon -> "Tekrar Göster" aksiyonu -->
      <div
        class="kr-detail-actions"
        v-if="reservation && reservation.UnVisible"
      >
        <span class="kr-unv-tag"
          ><i class="fa fa-eye-slash m-r-5"></i>Tekrar gösterme yapılmış</span
        >
        <Btn
          class="btn-warning btn-sm"
          @click="$emit('deUnvisible', reservation)"
        >
          <i class="fa fa-eye m-r-5"></i>Tekrar Göster
        </Btn>
      </div>
      <!-- Ozet seridi: support hangi rezervasyona baktigini ve durumunu tek
           bakista gorsun. Deger USTTE / etiket ALTTA: taranan sey deger, boylece
           hepsi ayni hizada. Sol aksan cizgisinin rengi rezervasyon durumu. -->
      <div class="kr-summary" :class="summary.typeClass" v-if="reservation">
        <div class="kr-sum-zone kr-sum-id">
          <div class="kr-sum-row">
            <span class="kr-voucher">{{ summary.voucher || "—" }}</span>
            <span class="kr-type" :class="summary.typeClass">{{
              summary.typeText
            }}</span>
          </div>
          <small>Voucher · #{{ reservation.Id }}</small>
        </div>

        <div class="kr-sum-zone" v-if="customerName">
          <div class="kr-sum-row">{{ customerName }}</div>
          <small>Müşteri</small>
        </div>

        <div class="kr-sum-zone" v-if="summary.provider">
          <div class="kr-sum-row">{{ summary.provider }}</div>
          <small>Sağlayıcı</small>
        </div>

        <div class="kr-sum-zone" v-if="summary.hotel">
          <div class="kr-sum-row">{{ summary.hotel }}</div>
          <small>Otel</small>
        </div>

        <div class="kr-sum-zone" v-if="summary.checkin">
          <div class="kr-sum-row">
            {{ summary.checkin }}
            <span class="kr-sum-sep">→</span>
            {{ summary.checkout }}
          </div>
          <small
            >Konaklama<template v-if="summary.nights">
              · {{ summary.nights }} gece</template
            ></small
          >
        </div>
      </div>

      <!-- Tab bar -->
      <ul class="kr-tabs">
        <li :class="{ active: tab === 'detay' }" @click="tab = 'detay'">
          <i class="fa fa-list-ul m-r-5"></i>Detay
        </li>
        <li :class="{ active: tab === 'json' }" @click="tab = 'json'">
          <i class="fa fa-code m-r-5"></i>JSON
        </li>
        <li :class="{ active: tab === 'logs' }" @click="tab = 'logs'">
          <i class="fa fa-history m-r-5"></i>Loglar
        </li>
      </ul>

      <!-- Paylasilan arama + alan filtresi: Detay ve JSON AYNI q ile filtrelenir.
           Logs sekmesinde anlamsiz (grid'in kendi floating filter'i var). -->
      <div class="kr-detay-bar" v-if="tab !== 'logs'">
        <div class="kr-search">
          <i class="fa fa-search kr-search-ic"></i>
          <input
            v-model="q"
            type="text"
            class="kr-search-in"
            placeholder="Alan ara — key veya değer"
          />
          <button
            v-if="q"
            type="button"
            class="kr-search-clear"
            title="Temizle"
            @click="q = ''"
          >
            ×
          </button>
        </div>
        <!-- Bos alan filtresi. Arama kutusunun yanindaki ikinci filtre oldugu
             icin segment: iki durum da gorunur, tiklanabilirligi belli ve
             sayilar uzerinde -> ayri sayac etiketine gerek kalmiyor. -->
        <div
          class="kr-seg"
          v-if="tab === 'detay'"
          role="group"
          aria-label="Alan filtresi"
        >
          <button
            type="button"
            :class="{ on: hideEmpty }"
            :aria-pressed="hideEmpty ? 'true' : 'false'"
            title="Yalnizca degeri olan alanlar"
            @click="hideEmpty = true"
          >
            Dolu <span class="kr-seg-n">{{ fieldCounts.filled }}</span>
          </button>
          <button
            type="button"
            :class="{ on: !hideEmpty }"
            :aria-pressed="!hideEmpty ? 'true' : 'false'"
            title="Bos alanlar dahil hepsi"
            @click="hideEmpty = false"
          >
            Tümü <span class="kr-seg-n">{{ fieldCounts.all }}</span>
          </button>
        </div>
        <span class="kr-field-count" v-if="tab === 'json'"
          >{{ matchCount }} alan</span
        >
      </div>

      <!-- DETAY: alt tab'li support gozlem ekrani. 170 alan tek sayfada takip
           edilemiyordu -> grup basina bir alt tab. Tab basligi grup adini zaten
           tasidigi icin ic kart basligi yok (dikey alan kazanci). -->
      <div v-show="tab === 'detay'" class="kr-detay-wrap">
        <!-- Alt gruplar SOL DIKEY nav. Yatay pill 11 grupta 1496px istiyordu,
             1102px alanda 2 satira tasiyor ve tab alani veriden buyuyordu.
             Dikey nav ayrica modalin yukseklik tabanini sabitler -> tab
             degistikce modal buyuyup kuculmez. -->
        <ul class="kr-subnav" v-if="subTabs.length">
          <li
            v-for="t in subTabs"
            :key="t.key"
            :class="{
              active: activeSub && activeSub.key === t.key,
              dim: !t.match,
            }"
            @click="subTab = t.key"
          >
            <span class="kr-subnav-label">{{ t.title }}</span>
            <span class="kr-sub-badge">{{
              q || hideEmpty ? t.match + "/" + t.total : t.total
            }}</span>
          </li>
        </ul>

        <div class="kr-detay" v-if="activeSub">
          <!-- Skaler grup -->
          <div class="kr-fields" v-if="activeSub.kind === 'fields'">
            <div class="kr-field" v-for="f in activeSub.rows" :key="f.key">
              <span class="kr-label">{{ f.key }}</span>
              <span
                v-if="f.bool !== undefined"
                class="kr-pill"
                :class="f.bool ? 'ok' : 'no'"
                >{{ f.display }}</span
              >
              <krCopyValue v-else :value="f.display" :empty="f.empty" />
              <span class="kr-id-name" v-if="idNames[f.key]">
                <i class="fa fa-arrow-right m-r-5"></i>{{ idNames[f.key] }}
              </span>
            </div>
          </div>

          <!-- Diziler & nesneler: recursive okunur gosterim (JSON nasil gelirse gelsin) -->
          <template v-else>
            <div class="kr-coll" v-for="c in activeSub.colls" :key="c.key">
              <div class="kr-coll-head">
                <span class="kr-coll-name">{{ c.key }}</span>
                <span class="kr-coll-type">{{
                  Array.isArray(c.value) ? "[ ]" : "{ }"
                }}</span>
                <span class="kr-count">{{ c.count }}</span>
              </div>
              <div class="kr-coll-body">
                <krJsonTree :value="c.value" :parentKey="c.key" />
              </div>
            </div>
            <div v-if="activeSub.emptyKeys.length" class="kr-empty-colls">
              <span class="kr-label">Boş</span>
              <span class="kr-empty-list">{{
                activeSub.emptyKeys.join(", ")
              }}</span>
            </div>
          </template>

          <div v-if="!activeSub.match" class="kr-noresult">
            <template v-if="q"
              ><i class="fa fa-search m-r-5"></i>“{{ q }}” bu grupta yok.</template
            >
            <template v-else
              ><i class="fa fa-eye-slash m-r-5"></i>Bu grupta dolu alan yok
              ({{ activeSub.total }} alanın hepsi boş).</template
            >
          </div>
        </div>

        <div v-else class="kr-noresult">
          <i class="fa fa-search m-r-5"></i>“{{ q }}” ile eşleşen alan yok.
        </div>
      </div>

      <!-- JSON: editor paneli -->
      <div v-show="tab === 'json'" class="kr-json-wrap">
        <div class="krJson-bar">
          <span class="krJson-meta"
            ><i class="fa fa-code m-r-5"></i>JSON · {{ lineCount }} satır</span
          >
          <button type="button" class="kr-copy-btn" @click="copyJson">
            <i class="fa m-r-5" :class="copied ? 'fa-check' : 'fa-copy'"></i
            >{{ copied ? "Kopyalandı" : "Kopyala" }}
          </button>
        </div>
        <div class="krJson-scroll">
          <div class="krJson-gutter" aria-hidden="true">
            <span v-for="n in lineCount" :key="n">{{ n }}</span>
          </div>
          <pre class="krJson"><code v-html="prettyHtml"></code></pre>
        </div>
      </div>

      <!-- LOGLAR: iki tip ayni kategoride. Alt tab YATAY (Detay'daki dikey nav
           degil): sadece 2 oge var ve grid'ler tum panel genisligini istiyor.
           Her ikisi de lazy - modal her cift-tikta aciliyor, pesin istek bos yuk. -->
      <div v-if="tab === 'logs'" class="kr-logs-wrap">
        <ul class="kr-logtabs">
          <li
            :class="{ active: logTab === 'rez' }"
            @click="logTab = 'rez'"
          >
            Rez Logs
            <span class="kr-sub-badge" v-if="logs">{{ logs.length }}</span>
          </li>
          <li
            :class="{ active: logTab === 'pms', dim: !pmsLogsSupported }"
            :title="
              pmsLogsSupported
                ? null
                : 'Bu PMS için PMS log tutulmuyor (SoftwareId ' +
                  reservation.SoftwareId +
                  ')'
            "
            @click="logTab = 'pms'"
          >
            PMS Logs
            <span
              class="kr-sub-badge"
              v-if="pmsLogs && pmsLogsSupported"
              >{{ pmsLogs.length }}</span
            >
          </li>
        </ul>

        <!-- Rez logs: kullanicilarin reze girip cikip ne yaptigi (ClickUp 86cawtg47) -->
        <div v-if="logTab === 'rez'" class="kr-logs">
          <load-area v-if="logsLoading"></load-area>
          <dataTable
            v-else-if="logs && logs.length"
            :name="'reservationLogs'"
            :rowHeight="26"
            :columnDefs="logColumns"
            :data="logs"
            :rowClassRules="logRowClassRules"
            :rowGroupPanelShow="false"
          ></dataTable>
          <div v-else-if="logs" class="kr-noresult">
            <i class="fa fa-history m-r-5"></i>Bu rezervasyon için log kaydı yok.
          </div>
        </div>

        <!-- PMS logs: POST KOLAYREZ/PMSLogs/Filter, yalniz ReservationId ile
             (diger filtreler zorunlu degil, bkz. PMSLogs/main.vue:235-241).
             Satira tiklayinca mevcut PMSLogs/show.vue modali acilir. -->
        <div v-else class="kr-logs">
          <div v-if="!pmsLogsSupported" class="kr-noresult">
            <i class="fa fa-ban m-r-5"></i>Bu PMS için PMS log tutulmuyor, bu
            yüzden sorgulanmıyor.
          </div>
          <load-area v-else-if="pmsLogsLoading"></load-area>
          <dataTable
            v-else-if="pmsLogs && pmsLogs.length"
            :name="'reservationPmsLogs'"
            :rowHeight="26"
            :columnDefs="pmsLogColumns"
            :data="pmsLogs"
            :rowClassRules="pmsLogRowClassRules"
            :rowGroupPanelShow="false"
            @cellClicked="pmsLogShow = $event.data"
          ></dataTable>
          <div v-else-if="pmsLogs" class="kr-noresult">
            <i class="fa fa-plug m-r-5"></i>Bu rezervasyon için PMS log kaydı yok.
          </div>
        </div>
      </div>
      </div>
    </template>
  </modal>

  <!-- PMS log detayi: PMSLogs ekranindaki mevcut modal aynen kullaniliyor.
       Log icerigini satirdaki LogFileUrl'den kendisi cekip Request/Response
       govdelerini parse ediyor (show.vue:151). -->
  <pmsLogShowModal
    v-if="pmsLogShow != null"
    :log="pmsLogShow"
    @close="pmsLogShow = null"
    @reload="
      pmsLogShow = null;
      pmsLogs = null;
      loadPmsLogs();
    "
  ></pmsLogShowModal>
</template>

<script>
import moment from "moment";
import krJsonTree from "./krJsonTree.vue";
import krCopyValue from "./krCopyValue.vue";
import pmsLogShowModal from "./../PMSLogs/show.vue";
// Row'a cift-tiklaninca acilan detay modali. 2 tab:
//  - Detay: support ekibi icin gruplu/okunur tum alanlar (bool/tarih formatli,
//           bilinmeyen/ekstra PMS alanlari "Diger" altinda -> hicbir sey gizlenmez).
//  - JSON : ham veri + kopyala.
// Gruplar gercek yanit uzerinden olculerek kuruldu (167 key: 160 skaler + 7 dizi).
// Onceki 7 grup skalerlerin yalniz %47'sini kapsiyordu, 84 alan "Diger"e dusuyordu.
// Hedef: "Diger" bos kalsin. Yeni alan gelirse gene "Diger"de gorunur (hicbir sey
// gizlenmez), oradan ilgili gruba tasinir.
const FIELD_GROUPS = [
  {
    title: "Genel",
    keys: [
      "Id", "Code", "Voucher", "OperatorVoucher", "ClientVoucher", "RezNo", "KNO",
      // Okunur metin burada; ham sayi (ConfirmationType) bilincli olarak
      // gruplanmadi -> "Diger"e duser.
      "OriginCode", "ConfirmationTypeText", "IsOnline", "CustomerId", "SoftwareId",
      "PMSIntegration", "UnVisible", "UnVisibleName", "UnVisibleDate",
    ],
  },
  {
    title: "Sağlayıcı",
    keys: [
      "ProviderName", "ProviderId", "CustomerProviderId", "Username", "ProviderAgency",
      "ProviderTourOperator", "FullAgencyName", "AgencyName", "ProviderMarket",
      "ProviderHotel", "ProviderRoomType", "ProviderBoardType", "ProviderRoomDetail",
      "ProviderPaxDetail", "ProviderDepartureCity",
      // Saglayicinin neye izin verdigi: support "neden konfirme edemiyorum" derken buraya bakar
      "ProviderConfirmable", "ProviderNotedConfirmable", "ProviderNotConfirmable",
      "ProviderDownloadable", "ProviderUnvisible",
    ],
  },
  {
    title: "Otel (Eşleşen)",
    keys: [
      "HotelName", "HotelId", "CountryCode", "CountryId", "DepartureCityName",
      "DepartureCityId", "OperatorId", "IsLocalOperator", "HotelAgencyCode",
      "HotelMarketCode", "HotelRoomTypeCode", "HotelBoardTypeCode",
      "HotelNationalityCode", "HotelSourceCode", "HotelLocationCode",
      "SoftwareCountryCode",
    ],
  },
  {
    title: "Misafirler / Pax",
    keys: [
      "Adult", "Child", "Infant", "Total", "RoomCount",
      // YCB = "Adult+Child+Infant" (or. "2+0+0"). API'den GELMEZ, main.vue:1691
      // satirlara kendisi ekliyor. Ayni sekilde ConfirmationTypeText de
      // main.vue:1679'da uretiliyor (Genel grubunda).
      "YCB",
      "Age1", "Age2", "Age3", "Age4",
      "IncorrectPaxInformation", "ChangeNameSurname", "UniqueGuestName",
      "OrderPersonNames",
    ],
  },
  {
    title: "Tarihler",
    keys: ["Checkin", "Checkout", "Duration", "ProviderSaleDate", "AddDate"],
  },
  {
    title: "Uçuş / Transfer",
    keys: [
      "ArrivalDate", "ArrivalFlightCode", "DepartureDate", "DepartureFlightCode",
      "ArrivalHourTo", "DepartureHourTo", "ArrivalClockToCheckin",
      "DepartureClockToCheckout", "AddinationalArrivalHour", "AddinationalArrivalMinute",
      "AddinationalDepartureHour", "AddinationalDepartureMinute",
    ],
  },
  {
    title: "Konfirmasyon",
    keys: [
      "ConfirmSoftwareSide", "ConfirmSoftwareSideSuccess", "ConfirmSoftwareSideDate",
      "ConfirmSoftwareSideUserId", "ConfirmSoftwareSideName",
      "ConfirmAgencySide", "ConfirmAgencySideSuccess", "ConfirmAgencySideDate",
      "ConfirmAgencySideUserId", "ConfirmAgencySideName",
      "NotConfirmAgencySide", "NotConfirmAgencySideSuccess", "NotConfirmAgencySideDate",
      "NotConfirmAgencySideUserId", "NotConfirmAgencySideName",
      "ConfirmationNote", "AgencyConfirmRequired",
      "MassConfirmable", "MassSoftwareConfirm", "MassAgencyConfirm", "MassNotConfirm",
    ],
  },
  {
    title: "Onay Akışı",
    keys: [
      "WaitApprove", "WaitApproveSavePMS", "WaitApproveConfirmAgency", "ApproveStatus",
      "ApproveSenderUserId", "ApproveSenderUsername", "ApproveSendDate",
      "ApproverUserId", "ApproverUsername", "ApproveDate",
      "ApproveMessage", "SendApproveMessage", "ApproveKey", "ApproveJson",
      "SendApproveBeforeSave", "SendApproveAfterSave", "CustomApproveFormat",
      "ApproveReasonId",
      "DrawbackedApprove", "DrawbackApproveUserId", "DrawbackApproveUsername",
      "DrawbackApproveDate",
    ],
  },
  {
    title: "Mail",
    keys: [
      "IsMail", "MailId", "Subject", "FromAddress", "ReceiveDate",
      "CCMailConfirm", "FromMailConfirm",
    ],
  },
  {
    title: "Notlar",
    keys: [
      "NoteCount", "NotesTo", "NotesToList", "ChildAgesNotesTo",
      "ChildAgesNotesLocation",
    ],
  },
  {
    title: "Dosya / Belge",
    keys: [
      "FileName", "FileDownloaded", "FileDownloadRetry", "DetailContentUrl",
      "SoftwareSideSavedJsonUrl",
    ],
  },
  // TourPrice* bilincli olarak HICBIR gruba yazilmadi -> "Diger"e duser.
  // "Diger" catch-all olarak zaten uretiliyor; ileride gelen bilinmeyen PMS
  // alanlarinin da dogal yeri orasi.
  {
    title: "Entegrasyon Ayarı",
    keys: [
      // Rezervasyon verisi degil, musteri/entegrasyon konfigurasyonu. Support
      // "bu otelde neden boyle davraniyor" derken buraya bakar.
      "DecDimension", "AutoCountrySelection", "CheckRepeat", "BoundKey", "SaleClock",
      "ShowDiscountCode", "P1", "P2", "DirectoryId", "Logo", "UsePerspectiva",
      "QuotaType", "UseStopSale", "DefaultQuotaMarket", "MarketToAgencyName",
      "FidelioAutoSave",
    ],
  },
];
// Bu PMS'ler icin backend PMSLogs satiri yazmiyor -> istek atmiyoruz.
// 1, 2 = Elektra (legacy), 6 = ElektraWeb. Id->PMS eslesmesi repoda merkezi
// bir tabloda degil, kullanim yerlerinden dogrulandi (or. Elektra param
// alanlari customers/detail/hotels/upsert.vue:2419; ElektraWeb icin
// Reservations/Calculate/ElektraWeb oldReservations/detail/elektraWeb.vue:1290).
const PMS_LOG_UNSUPPORTED_SOFTWARE_IDS = [1, 2, 6];
const CONF_TYPE = {
  0: { text: "None", cls: "none" },
  "-1": { text: "None", cls: "none" },
  1: { text: "New", cls: "new" },
  2: { text: "Changed", cls: "changed" },
  3: { text: "Cancelled", cls: "cancelled" },
  4: { text: "Booked", cls: "booked" },
  5: { text: "Request", cls: "request" },
};
export default {
  name: "reservationDetailModal",
  components: { krJsonTree, krCopyValue, pmsLogShowModal },
  emits: ["close", "deUnvisible"],
  props: {
    reservation: { type: Object, default: null },
    // Yanitta CustomerId var ama adi yok; parent ekran musteri listesini zaten
    // yukledigi icin adi oradan aliyoruz (bkz. main.vue detailCustomerName).
    customerName: { type: String, default: null },
    // { alanAdi: cozulmus ad } — cikplak sayi donen *Id alanlari icin. Deger
    // DEGISTIRILMEZ, yanina etiket olarak eklenir: Detay'da gosterilen her sey
    // JSON'dan gelmeli, ad yalnizca zenginlestirme.
    idNames: { type: Object, default: () => ({}) },
  },
  data() {
    // subTab   : kullanicinin sectigi alt tab anahtari; gosterileni `activeSub` cozer.
    // hideEmpty: gercek yanitta 167 alanin 78'i null (%47). Varsayilan olarak
    //            gizli baslar, badge'lerde "gosterilen/toplam" yazdigi icin bir
    //            seyin saklandigi hep gorunur.
    return {
      tab: "detay",
      subTab: null,
      hideEmpty: true,
      copied: false,
      copyTimer: null,
      q: "",
      // Loglar. null = henuz cekilmedi, [] = cekildi ve bos.
      logTab: "rez",
      logs: null,
      logsLoading: false,
      pmsLogs: null,
      pmsLogsLoading: false,
      pmsLogShow: null,
      // HasError: PMSLogs ekraninin kendi kullandigi alan (PMSLogs/main.vue:142).
      // Onceden ErrorMessage'a bakiyordum -> ayni kayit iki ekranda farkli
      // isaretlenebiliyordu.
      pmsLogRowClassRules: {
        "kr-row-fail": (params) =>
          !!(params && params.data && params.data.HasError),
      },
      pmsLogColumns: [
        {
          headerName: "Tarih",
          field: "Date",
          width: 150,
          sortable: true,
          filter: "agTextColumnFilter",
          // PMSLogs/main.vue:205-212 ile AYNI donusum: bu tablodaki Date
          // GMT kaymasi icerdigi icin offset cikarilir. Farkli formatlarsak
          // ayni kayit iki ekranda iki farkli saat gosterir.
          valueFormatter: function(params) {
            if (params.value == null) return null;
            const diff = new Date().getTimezoneOffset();
            const d = new Date(params.value);
            return moment(d.setMinutes(d.getMinutes() - diff)).format(
              "DD.MM.YYYY HH:mm"
            );
          },
        },
        {
          headerName: "Fonksiyon",
          field: "FunctionName",
          flex: 1,
          minWidth: 200,
          sortable: true,
          filter: "agTextColumnFilter",
        },
        {
          headerName: "Hata Mesajı",
          field: "ErrorMessage",
          flex: 1,
          minWidth: 180,
          sortable: true,
          filter: "agTextColumnFilter",
        },
      ],
      // ag-grid prop'lari STABIL referans olmali: inline obj/fn her render'da
      // yeni referans uretir -> deep-watch -> header rebuild -> filtre focus kacar.
      // GLOBAL "danger" class'i KULLANILMIYOR: ag-grid-overrides.css:139
      // `.ag-row.danger`a color:#fff + background:#fb6a85 veriyor. Sadece
      // background'i ezmek beyaz yazi/beyaz zemin (okunamaz satir) uretiyordu.
      // Kendi class'imiz -> miras alinan bagaj yok.
      logRowClassRules: {
        "kr-row-fail": (params) =>
          !(params && params.data && params.data.Success),
      },
      logColumns: [
        {
          headerName: "Tarih",
          field: "Date",
          width: 150,
          sortable: true,
          filter: "agTextColumnFilter",
          valueFormatter: function(params) {
            return params.value == null
              ? null
              : moment(new Date(params.value)).format("DD.MM.YYYY HH:mm:ss");
          },
        },
        {
          headerName: "Kullanıcı",
          field: "Name",
          flex: 1,
          minWidth: 140,
          sortable: true,
          filter: "agTextColumnFilter",
        },
        {
          headerName: "Kul. Id",
          field: "UserId",
          width: 90,
          sortable: true,
          filter: "agNumberColumnFilter",
        },
        {
          headerName: "İşlem",
          field: "ProcessType",
          width: 120,
          sortable: true,
          filter: "agTextColumnFilter",
        },
        {
          headerName: "Sonuç",
          field: "Success",
          width: 110,
          sortable: true,
          // Text filter: valueGetter "Başarılı"/"Hata" dondurdugu icin floating
          // filter'a yazilan metin bunlarla eslesir. dataTable'in defaultColDef
          // filterParams'i Turkce-duyarli oldugu icin "basarili" da tutar.
          filter: "agTextColumnFilter",
          valueGetter: function(params) {
            if (params.data == undefined) return null; // grup satiri guard
            return params.data.Success ? "Başarılı" : "Hata";
          },
          cellRenderer: function(params) {
            if (params.data == undefined) return params.value;
            const ok = !!params.data.Success;
            return (
              '<span class="kr-log-badge ' +
              (ok ? "ok" : "no") +
              '">' +
              (ok ? "Başarılı" : "Hata") +
              "</span>"
            );
          },
        },
        {
          headerName: "Hata Mesajı",
          field: "ErrorMessage",
          flex: 1,
          minWidth: 160,
          sortable: true,
          filter: "agTextColumnFilter",
        },
        {
          headerName: "Log Dosyası",
          field: "LogFile",
          width: 120,
          filter: false,
          cellRenderer: function(params) {
            if (params.value == null) return null;
            // DIKKAT: klasor "reservationlogs". Eski client logs.vue'sundaki
            // "/logs/" yolu bu endpoint icin gecersiz.
            return (
              '<a class="kr-log-link" target="_blank" rel="noopener" href="' +
              "https://reservations.ams3.digitaloceanspaces.com/reservationlogs/" +
              params.value +
              '">Aç</a>'
            );
          },
        },
      ],
    };
  },
  computed: {
    // Tam kayit (Kopyala bunu kullanir — filtreden bagimsiz).
    fullPretty() {
      try {
        return JSON.stringify(this.reservation, null, 2);
      } catch (e) {
        return String(this.reservation);
      }
    },
    // Gosterilen JSON: q varsa yalniz eslesen top-level key'ler (Detay ile AYNI set).
    pretty() {
      const r = this.reservation || {};
      if (!this.q.trim()) return this.fullPretty;
      const set = this.shownKeySet;
      const obj = {};
      Object.keys(r).forEach((k) => {
        if (set.has(k)) obj[k] = r[k];
      });
      try {
        return JSON.stringify(obj, null, 2);
      } catch (e) {
        return String(obj);
      }
    },
    lineCount() {
      return this.pretty ? this.pretty.split("\n").length : 0;
    },
    // JSON sozdizimi renklendirmesi (once escape, sonra token'lari span'le).
    prettyHtml() {
      const esc = this.pretty
        .replace(/&/g, "&amp;")
        .replace(/</g, "&lt;")
        .replace(/>/g, "&gt;");
      return esc.replace(
        /("(\\u[a-zA-Z0-9]{4}|\\[^u]|[^\\"])*"(\s*:)?|\b(true|false|null)\b|-?\d+(?:\.\d*)?(?:[eE][+-]?\d+)?)/g,
        (m) => {
          let cls = "jh-num";
          if (/^"/.test(m)) cls = /:$/.test(m) ? "jh-key" : "jh-str";
          else if (/true|false/.test(m)) cls = "jh-bool";
          else if (/null/.test(m)) cls = "jh-null";
          return '<span class="' + cls + '">' + m + "</span>";
        }
      );
    },
    summary() {
      const r = this.reservation || {};
      const ct = CONF_TYPE[r.ConfirmationType] || { text: "—", cls: "none" };
      return {
        voucher: r.Voucher,
        provider: r.ProviderName,
        hotel: r.HotelName || r.ProviderHotel,
        checkin: r.Checkin ? this.fmtDate(r.Checkin, false) : null,
        checkout: r.Checkout ? this.fmtDate(r.Checkout, false) : null,
        // Duration yanitta zaten var ama seride gosterilmiyordu; "kac gece"
        // support'un surekli sordugu sey.
        nights: r.Duration,
        typeText: ct.text,
        typeClass: "t-" + ct.cls,
      };
    },
    groups() {
      const r = this.reservation || {};
      const used = {};
      const out = [];
      FIELD_GROUPS.forEach((g) => {
        const rows = [];
        g.keys.forEach((k) => {
          if (Object.prototype.hasOwnProperty.call(r, k) && !this.isCollection(r[k])) {
            used[k] = true;
            rows.push({ key: k, ...this.formatValue(k, r[k]) });
          }
        });
        if (rows.length) out.push({ title: g.title, rows });
      });
      // "Diger": gruplara girmeyen skaler alanlar -> PMS'e gore degisen ekstra
      // alanlar dahil hicbir sey gizlenmesin.
      const otherRows = [];
      Object.keys(r).forEach((k) => {
        if (used[k] || this.isCollection(r[k])) return;
        otherRows.push({ key: k, ...this.formatValue(k, r[k]) });
      });
      if (otherRows.length) out.push({ title: "Diğer", rows: otherRows });
      return out;
    },
    collections() {
      const r = this.reservation || {};
      return Object.keys(r)
        .filter((k) => this.isCollection(r[k]))
        .map((k) => {
          const v = r[k];
          const count = Array.isArray(v) ? v.length : Object.keys(v).length;
          return { key: k, count: count, value: v };
        });
    },
    nonEmptyCollections() {
      return this.collections.filter((c) => c.count > 0);
    },
    emptyCollectionKeys() {
      return this.collections.filter((c) => c.count === 0).map((c) => c.key);
    },
    // Arama index'i: her top-level key icin "key + icindeki TUM degerler" (ic ice
    // dahil), kucuk harfe indirilmis. Computed oldugu icin yalniz `reservation`
    // degisince hesaplanir; her tus vurusunda degil.
    // Neden gerekti: onceden yalniz top-level primitive degerler aranıyordu, bu
    // yuzden Persons[0].Name = "AHMET" varken "AHMET" aramasi 0 sonuc donuyor VE
    // eslesmeyi iceren Persons kartini Detay'dan kaldiriyordu (JSON sekmesini de
    // bosaltiyordu). Yani veri ekranda hicbir yerde gorunmuyordu.
    searchIndex() {
      const r = this.reservation || {};
      const out = {};
      Object.keys(r).forEach((k) => {
        out[k] = (k + " " + this.flatten(r[k], 0)).toLowerCase();
      });
      return out;
    },
    // TEK filtre kaynagi: q'yu iceren TOP-LEVEL key'ler. Scalar -> key VEYA deger;
    // koleksiyon -> key. Detay, JSON ve alan sayaci hepsi bunu kullanir (birebir ayni).
    shownKeySet() {
      const r = this.reservation || {};
      const keys = Object.keys(r);
      const q = this.q.trim().toLowerCase();
      if (!q) return new Set(keys);
      const set = new Set();
      keys.forEach((k) => {
        // Bos koleksiyonlar da adiyla aranabilir. Onceden atiliyorlardi: "Notes"
        // yazip "eslesen alan yok" gormek yanlisti (Notes VAR, sadece bos).
        // Ic ice deger bulunabiliyorken tam key adinin bulunamamasi tutarsizdi.
        // searchIndex key'i de iceriyor, ic ice degerleri de -> tek kontrol yeter.
        if ((this.searchIndex[k] || "").indexOf(q) > -1) set.add(k);
      });
      return set;
    },
    matchCount() {
      return this.shownKeySet.size;
    },
    filteredCollections() {
      const set = this.shownKeySet;
      return this.nonEmptyCollections.filter((c) => set.has(c.key));
    },
    // Alt tab listesi: her skaler grup + koleksiyonlar icin "Diziler".
    // Eslesmeyen/bos tab LISTEDEN KALKMAZ, soluk gosterilir ve badge 0 olur ->
    // alanin baska grupta oldugu gorulur. Tab'i silmek "alan yok" izlenimi verirdi.
    subTabs() {
      const set = this.shownKeySet;
      const out = this.groups.map((g) => {
        let rows = g.rows;
        if (this.q) rows = rows.filter((f) => set.has(f.key));
        if (this.hideEmpty) rows = rows.filter((f) => !f.empty);
        return {
          key: g.title,
          title: g.title,
          kind: "fields",
          total: g.rows.length,
          match: rows.length,
          rows: rows,
        };
      });
      if (this.collections.length) {
        let colls = this.q ? this.filteredCollections : this.nonEmptyCollections;
        // Bos koleksiyonlar sadece ISIM olarak listelenir (gosterilecek deger yok).
        // Aramada: adi eslesenler gorunur, boylece "Notes" yazan sonuc alir.
        const emptyKeys = this.q
          ? this.emptyCollectionKeys.filter((k) => set.has(k))
          : this.hideEmpty
          ? []
          : this.emptyCollectionKeys;
        out.push({
          key: "__coll__",
          title: "Diziler",
          kind: "collections",
          total: this.collections.length,
          match: colls.length + emptyKeys.length,
          colls: colls,
          emptyKeys: emptyKeys,
        });
      }
      return out;
    },
    // Gosterilen alt tab. subTab'a saygi duyar (kullanici soluk bir tab'i bilerek
    // acabilir); yalniz secim gecersizse ilk dolu tab'a duser. Aramada atlama
    // isini `q` watcher'i yapar.
    activeSub() {
      const tabs = this.subTabs;
      if (!tabs.length) return null;
      return (
        tabs.find((t) => t.key === this.subTab) ||
        tabs.find((t) => t.match > 0) ||
        tabs[0]
      );
    },
    // Bu rezervasyonun PMS'i log uretiyor mu. Uretmiyorsa sekme gizlenmez,
    // soluk gosterilir ve sebebi yazilir: gizlemek "PMS log neden yok?"
    // sorusunu dogurur, soluk gostermek cevaplar.
    pmsLogsSupported() {
      const raw = this.reservation && this.reservation.SoftwareId;
      if (raw == null || raw === "") return true; // bilinmiyorsa engellemeyiz
      // Number(): yanit SoftwareId'yi string olarak dondururse ("6") indexOf
      // katı esitlik yuzunden eslesmez ve gate sessizce atlanirdi.
      const sid = Number(raw);
      if (isNaN(sid)) return true;
      return PMS_LOG_UNSUPPORTED_SOFTWARE_IDS.indexOf(sid) === -1;
    },
    // Segment sayaclari. hideEmpty'den BAGIMSIZ hesaplanir: aksi halde "Dolu"
    // sayisi filtreyi degistirince kayardi. Arama varsa ona saygi duyar.
    fieldCounts() {
      const set = this.shownKeySet;
      let filled = 0;
      let all = 0;
      this.groups.forEach((g) => {
        g.rows.forEach((f) => {
          if (this.q && !set.has(f.key)) return;
          all++;
          if (!f.empty) filled++;
        });
      });
      this.collections.forEach((c) => {
        if (this.q && !set.has(c.key)) return;
        all++;
        if (c.count > 0) filled++;
      });
      return { filled: filled, all: all };
    },
  },
  beforeUnmount() {
    // Modal kapandiktan sonra state'e yazmasin
    clearTimeout(this.copyTimer);
  },
  watch: {
    // Arama degisti -> ilk eslesen gruba atla, yoksa aranan alan baska tab'ta
    // kalir ve "yok" sanilir. Kullanicinin sonradan tikladigi grup korunur
    // (watcher yalniz q degisince calisir, activeSub subTab'a saygi duyar).
    q() {
      const first = this.subTabs.find((t) => t.match > 0);
      this.subTab = first ? first.key : null;
    },
    // Log istegi YALNIZ ilgili sekmeye tiklanınca atilir; modal her cift-tikta
    // aciliyor, pesin cekmek bos yuk. null = "henuz cekilmedi".
    tab() {
      this.loadActiveLog();
    },
    logTab() {
      this.loadActiveLog();
    },
    // Ayni instance baska bir rezervasyon icin kullanilirsa eski loglar
    // gorunmesin (parent v-if ile unmount ediyor ama bu garanti degil).
    reservation() {
      this.resetLogs();
    },
  },
  methods: {
    isCollection(v) {
      return Array.isArray(v) || (v !== null && typeof v === "object");
    },
    // Bir degerin icindeki tum primitive'leri tek metne indirir (searchIndex icin).
    // depth siniri: kendine referans veren bir yapida sonsuz donguye girmesin.
    flatten(v, depth) {
      if (v === null || v === undefined) return "";
      if (typeof v !== "object") return String(v);
      if (depth > 6) return "";
      let out = "";
      if (Array.isArray(v)) {
        for (let i = 0; i < v.length; i++) {
          out += " " + this.flatten(v[i], depth + 1);
        }
        return out;
      }
      const keys = Object.keys(v);
      for (let i = 0; i < keys.length; i++) {
        // Ic ice key adlari da aranabilir olsun (or. "Passport" yazip bulmak).
        out += " " + keys[i] + " " + this.flatten(v[keys[i]], depth + 1);
      }
      return out;
    },
    isDateKey(k) {
      return k === "Checkin" || k === "Checkout" || /Date$/.test(k);
    },
    fmtDate(value, withTime) {
      const d = new Date(value);
      if (isNaN(d.getTime())) return String(value);
      return moment(d).format(withTime ? "DD.MM.YYYY HH:mm" : "DD.MM.YYYY");
    },
    formatValue(key, value) {
      if (value === null || value === undefined || value === "") {
        return { display: "—", empty: true };
      }
      if (typeof value === "boolean") {
        return { display: value ? "Evet" : "Hayır", bool: value };
      }
      if (this.isDateKey(key) && typeof value === "string") {
        const hasTime = /T\d/.test(value) && !/T00:00:00/.test(value);
        return { display: this.fmtDate(value, hasTime) };
      }
      return { display: String(value) };
    },
    resetLogs() {
      this.logTab = "rez";
      this.logs = null;
      this.logsLoading = false;
      this.pmsLogs = null;
      this.pmsLogsLoading = false;
      this.pmsLogShow = null;
    },
    loadActiveLog() {
      if (this.tab !== "logs") return;
      if (this.logTab === "rez" && this.logs === null) this.loadLogs();
      // Log uretmeyen PMS'te istek atilmaz (bkz. pmsLogsSupported).
      if (this.logTab === "pms" && this.pmsLogs === null && this.pmsLogsSupported)
        this.loadPmsLogs();
    },
    loadPmsLogs() {
      // PMSLogs/main.vue ile ayni endpoint; filtrelerin hicbiri zorunlu degil,
      // ReservationId tek basina yeterli (PMSLogs/main.vue:235-241, 268-269).
      const id = this.reservation && this.reservation.Id;
      if (!id || this.pmsLogsLoading) return;
      this.pmsLogsLoading = true;
      this.$appAxiosAdmin
        .post(`KOLAYREZ/PMSLogs/Filter`, {
          // String: bu endpoint'in iki mevcut caginisi da string yolluyor
          // (PMSLogs ekraninda text input, client pmsLogs/main.vue'da String()).
          // Numeric yol denenmemis, riske girmiyoruz.
          ReservationId: String(id),
          // SoftwareId/HotelId BILEREK null: backend filtreleri AND'liyorsa,
          // otelin PMS'i log yazildiktan sonra degistiyse rezervasyonun guncel
          // SoftwareId'si eski loglari disarida birakir ve "log yok" gorunur.
          SoftwareId: null,
          HotelId: null,
          StartDate: null,
          EndDate: null,
        })
        .then((r) => {
          this.pmsLogsLoading = false;
          this.pmsLogs = r.data || [];
        })
        .catch((err) => {
          this.pmsLogsLoading = false;
          this.pmsLogs = [];
          console.error("KOLAYREZ/PMSLogs/Filter basarisiz:", err);
          this.$isError(err);
        });
    },
    close() {
      // Veri tutulmuyor: kapanista log verisi ve sekme secimi sifirlanir.
      this.resetLogs();
      this.tab = "detay";
      this.$emit("close");
    },
    loadLogs() {
      // ClickUp 86cawtg47: GET Admin/KOLAYREZ/Reservations/Logs/{ReservationId}
      // ($appAxiosAdmin baseURL'i .../Admin/ ile bitiyor)
      const id = this.reservation && this.reservation.Id;
      if (!id || this.logsLoading) return;
      this.logsLoading = true;
      this.$appAxiosAdmin
        .get(`KOLAYREZ/Reservations/Logs/${id}`)
        .then((r) => {
          this.logsLoading = false;
          this.logs = r.data || [];
        })
        .catch((err) => {
          this.logsLoading = false;
          // [] yaz: tekrar tab'a gelindiginde sonsuz istek donmesin, kullanici
          // hatayi swal'da gordu.
          this.logs = [];
          console.error(`KOLAYREZ/Reservations/Logs/${id} basarisiz:`, err);
          this.$isError(err);
        });
    },
    copyJson() {
      // Global yardimciya yonlendirildi: HTTP'de ve izin reddinde ARTIK SESSIZ
      // KALMIYOR (onceden ikisi de sessizce donuyordu). silentSuccess=true ->
      // basari geri bildirimi burada, dugmenin uzerindeki tik.
      Promise.resolve(this.$root.clipboardCopy(this.fullPretty, true)).then(
        (ok) => {
          if (ok === false) return;
          this.copied = true;
          clearTimeout(this.copyTimer);
          this.copyTimer = setTimeout(() => {
            this.copied = false;
          }, 1500);
        }
      );
    },
  },
};
</script>

<style scoped>
/* modal-body shared component'te p-0 geliyor -> icerige ferah padding ver. */
/* Dikey kap: chrome (aksiyon/ozet/tab/arama) sabit, yalniz aktif sekmenin
   govdesi kayar. Yukseklik siniri custom.css'teki .reservationDetailModal
   kurallarindan gelir; burada sadece kalan alani paylastiriyoruz. */
.kr-modal-body {
  padding: 16px 18px;
  display: flex;
  flex-direction: column;
  flex: 1 1 auto;
  min-height: 0;
}
/* UnVisible aksiyon seridi */
.kr-detail-actions {
  flex: 0 0 auto;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 8px 12px;
  margin-bottom: 12px;
  border-radius: 8px;
  background: var(--bg-warning, #fff8e1);
  border: 1px solid var(--border-warning, #ffe0a3);
}
.kr-unv-tag {
  font-size: 12.5px;
  font-weight: 600;
  color: var(--text-warning, #b26a00);
}
/* ── Ozet seridi ────────────────────────────────────────────────────────────
   Tek satirlik "kimlik karti". Onceki halinde 6 oge de ayni agirliktaydi;
   voucher (support'un ve otelin konustugu asil kimlik) "Tür" ile ayni boyutta
   goruunuyordu. Simdi: voucher hakim, geri kalani sessiz metadata, bolgeler
   ince dikey cizgiyle ayrilmis. Yukseklik degismedi (gene 2 satir), yani asagidaki
   alan panelinden yer calmiyor. */
.kr-summary {
  flex: 0 0 auto;
  display: flex;
  flex-wrap: wrap;
  align-items: stretch;
  gap: 0;
  gap: 30px;
  padding: 14px 18px;
  margin-bottom: 12px;
  border-radius: 10px;
  background: var(--bg-surface, #fff);
  border: 1px solid var(--border-default, #e2e4e9);
  /* Kartin sol aksani = rezervasyon durumu. Cok rezervasyon tarayan support
     iptal olani okumadan once ayirt eder. */
  border-left: 3px solid var(--border-default, #d6d6dd);
}
/* Durum renkleri KATEGORIK: 4 ayri hue + notr, boylece durumlar birbirinden
   ayirt edilir. Yesil kaldirildi (proje rengi mavi); "New" en sik durum oldugu
   icin proje mavisini o aldi, "Booked" cakismamak icin mora tasindi. */
.kr-summary.t-new { border-left-color: #1e88e5; }
.kr-summary.t-changed { border-left-color: #d98500; }
.kr-summary.t-cancelled { border-left-color: #c53030; }
.kr-summary.t-booked { border-left-color: #7c3aed; }

/* Dikey ayirici cizgi YOK: 4 bolge arasi hairline + sol aksan + pill birlikte
   "ic ice ve ince" hissi veriyordu. Ayrim artik bosluktan (gap: 30px). */
.kr-sum-zone {
  min-width: 0;
}
/* Deger satiri: bolgeler arasi ust hiza tutar. */
.kr-sum-row {
  display: flex;
  align-items: center;
  gap: 8px;
  min-width: 0;
  font-size: 14.5px;
  font-weight: 600;
  line-height: 1.35;
  color: var(--text-primary, #1c1c22);
  word-break: break-word;
}
/* Etiketler: 10.5px uppercase + tertiary renk arka planda kayboluyordu.
   uppercase kaldirildi (kucuk puntoda okumasi zor), punto ve kontrast artti. */
.kr-sum-zone small {
  display: block;
  margin-top: 3px;
  font-size: 11.5px;
  font-weight: 600;
  color: var(--text-secondary, #6b6b75);
  white-space: nowrap;
}
/* Voucher: bir kod, o yuzden monospace (JSON tab'i ve alan key'leriyle ayni
   sinyal) ve serideki en buyuk oge -> kart tek bakista "hangi rezervasyon"
   sorusunu cevaplar. */
.kr-voucher {
  font-family: "SFMono-Regular", Consolas, "Liberation Mono", Menlo, monospace;
  font-size: 19px;
  font-weight: 700;
  letter-spacing: -0.01em;
  line-height: 1.2;
  color: var(--text-primary, #14141a);
}
.kr-sum-id small {
  /* Voucher'in altinda ikincil kimlik: rezervasyon Id'si */
  font-family: "SFMono-Regular", Consolas, "Liberation Mono", Menlo, monospace;
}
.kr-sum-sep {
  color: var(--text-tertiary, #b4b4bd);
  font-weight: 400;
}
.kr-type {
  flex: 0 0 auto;
  padding: 2px 10px;
  border-radius: 20px;
  font-size: 11.5px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.03em;
}
.kr-type.t-new { background: #e8f2fd; color: #1565c0; }
.kr-type.t-changed { background: #fff3e0; color: #a85f00; }
.kr-type.t-cancelled { background: #fde8e8; color: #c53030; }
.kr-type.t-booked { background: #f3e8ff; color: #6d28d9; }
.kr-type.t-request,
.kr-type.t-none { background: var(--bg-tertiary, #ededf1); color: var(--text-secondary, #6b6b75); }

/* Dar ekranda bolge cizgileri yatayda anlamsizlasir -> alt alta gecer. */
@media (max-width: 880px) {
  .kr-summary {
    padding: 10px 14px;
  }
  .kr-sum-zone {
    flex: 1 1 100%;
    padding: 8px 0 0;
    border-left: 0;
    border-top: 1px solid var(--border-default, #e6e6ea);
  }
  .kr-sum-zone:first-child {
    padding-top: 0;
    border-top: 0;
  }
}

/* Tab bar */
.kr-tabs {
  flex: 0 0 auto;
  display: flex;
  gap: 4px;
  list-style: none;
  margin: 0 0 14px;
  padding: 0;
  border-bottom: 2px solid var(--border-default, #eaeaef);
}
.kr-tabs li {
  cursor: pointer;
  padding: 8px 16px;
  font-size: 13px;
  font-weight: 600;
  color: var(--text-secondary, #7a7a85);
  border-bottom: 2px solid transparent;
  margin-bottom: -2px;
  transition: color 0.12s ease, border-color 0.12s ease;
}
.kr-tabs li:hover { color: var(--text-primary, #23232a); }
.kr-tabs li.active {
  color: var(--color-brand-500, #1e88e5);
  border-bottom-color: var(--color-brand-500, #1e88e5);
}

/* Detay filtre cubugu */
.kr-detay-bar {
  flex: 0 0 auto;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 12px;
}
/* Detay kabi: solda grup nav'i, sagda alan paneli. */
.kr-detay-wrap {
  display: flex;
  gap: 12px;
  flex: 1 1 auto;
  min-height: 0;
}
/* Grup nav'i (2. seviye) DIKEY. Yatay pill 11 grupta 1496px istiyordu, panelde
   1102px var -> 2 satira tasiyip veriden fazla yer kapliyordu. Dikey nav grup
   sayisiyla buyumez ve modalin yukseklik tabanini sabitler (tab degistikce
   modal zipla-kucul yapmaz). */
.kr-subnav {
  flex: 0 0 200px;
  display: flex;
  flex-direction: column;
  /* Okunabilirlik/tiklanabilirlik hepsini sigdirmaktan onemli: ogeler ferah,
     14 grup kaba sigmadiginda nav kendi icinde kayar (overflow-y asagida). */
  gap: 3px;
  list-style: none;
  margin: 0;
  padding: 0;
  /* Cok grup olursa nav kendi icinde kayar, modal buyumez. */
  overflow-y: auto;
  overscroll-behavior: contain;
  min-height: 0;
}
.kr-subnav li {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  cursor: pointer;
  /* Rahat tiklama hedefi: ~34px yukseklik */
  min-height: 34px;
  padding: 7px 10px;
  border-radius: 7px;
  border-left: 2px solid transparent;
  font-size: 12.5px;
  font-weight: 600;
  line-height: 1.35;
  color: var(--text-secondary, #6b6b75);
  transition: background 0.12s ease, color 0.12s ease, border-color 0.12s ease;
}
/* Tiklanabilirlik sinyali: hover'da zemin + sol aksan belirir */
.kr-subnav li:hover:not(.active) {
  background: var(--bg-secondary, #f2f3f6);
  border-left-color: var(--border-default, #cfd3d8);
  color: var(--text-primary, #23232a);
}
/* Aktif: dolu brand zemin yerine hafif ton + sol aksan. Sol nav'da dolu zemin
   agir duruyor, ayrica ana tab bar'la yarisiyor. */
.kr-subnav li.active {
  /* Onceki ton teal'e kaciyordu -> aktif grup yesil gorunuyordu. Mavi ton. */
  background: var(--bg-selected, #e8f2fd);
  border-left-color: var(--color-brand-500, #1e88e5);
  color: var(--color-brand-600, #1565c0);
}
/* Gosterilecek alani olmayan grup: gizlenmez, soluklar -> alanin baska grupta
   oldugu bilgisi kaybolmasin. */
.kr-subnav li.dim {
  opacity: 0.45;
}
.kr-subnav-label {
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.kr-sub-badge {
  flex: 0 0 auto;
  padding: 0 6px;
  border-radius: 20px;
  background: var(--bg-tertiary, #ededf1);
  /* #7a7a85 -> 3.63 kontrast (dusuk); #5a5a63 ile 5.6 */
  color: var(--text-secondary, #5a5a63);
  font-size: 10.5px;
  font-weight: 700;
  font-variant-numeric: tabular-nums;
}
.kr-subnav li.active .kr-sub-badge {
  background: var(--color-brand-500, #1e88e5);
  color: #fff;
}
/* Kayan panel: modal buyumek yerine burasi scroll eder. Grup basligi yok,
   aktif alt tab zaten adi tasiyor. overscroll-behavior -> panel sonuna gelince
   sayfa/dis kap kaymaya baslamasin. */
.kr-detay {
  flex: 1 1 auto;
  min-height: 0;
  overflow-y: auto;
  overscroll-behavior: contain;
  background: var(--bg-surface, #fff);
  border: 1px solid var(--border-default, #e6e6ea);
  border-radius: 10px;
  padding: 14px 16px;
}
.kr-search {
  position: relative;
  flex: 1 1 auto;
  max-width: 380px;
}
.kr-search-ic {
  position: absolute;
  left: 11px;
  top: 50%;
  transform: translateY(-50%);
  font-size: 12px;
  color: var(--text-tertiary, #a7a7af);
  pointer-events: none;
}
.kr-search-in {
  width: 100%;
  height: 34px;
  padding: 0 30px;
  border: 1px solid var(--border-default, #e0e0e6);
  border-radius: 8px;
  font-size: 13px;
  color: var(--text-primary, #23232a);
  background: var(--bg-surface, #fff);
  outline: none;
  transition: border-color 0.12s ease, box-shadow 0.12s ease;
}
.kr-search-in:focus {
  border-color: var(--color-brand-500, #1e88e5);
  box-shadow: 0 0 0 3px rgba(30, 136, 229, 0.14);
}
.kr-search-clear {
  position: absolute;
  right: 8px;
  top: 50%;
  transform: translateY(-50%);
  width: 20px;
  height: 20px;
  padding: 0;
  border: 0;
  border-radius: 50%;
  background: var(--bg-tertiary, #ededf1);
  color: var(--text-secondary, #5a5a63);
  font-size: 15px;
  line-height: 1;
  cursor: pointer;
}
.kr-search-clear:hover {
  background: var(--border-default, #dcdce2);
}
.kr-field-count {
  flex: 0 0 auto;
  font-size: 12px;
  font-weight: 600;
  color: var(--text-secondary, #8a8a93);
  white-space: nowrap;
}
/* Bos alan filtresi (segment). Iki durum da gorunur oldugu icin "tiklanabilir mi"
   ve "alternatifi ne" sorusu kalmiyor; sayilar segmentin uzerinde. */
.kr-seg {
  flex: 0 0 auto;
  display: inline-flex;
  padding: 2px;
  border: 1px solid var(--border-default, #e0e0e6);
  border-radius: 8px;
  background: var(--bg-tertiary, #f1f1f5);
}
.kr-seg button {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 4px 11px;
  border: 0;
  border-radius: 6px;
  background: transparent;
  color: var(--text-secondary, #6b6b75);
  font-size: 12px;
  font-weight: 600;
  white-space: nowrap;
  cursor: pointer;
  transition: background 0.12s ease, color 0.12s ease, box-shadow 0.12s ease;
}
.kr-seg button:hover:not(.on) {
  color: var(--text-primary, #23232a);
}
.kr-seg button.on {
  background: var(--bg-surface, #fff);
  color: var(--color-brand-600, #1565c0);
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.08);
}
.kr-seg-n {
  padding: 0 5px;
  border-radius: 20px;
  background: var(--bg-tertiary, #e7e7ec);
  font-size: 10.5px;
  font-weight: 700;
  font-variant-numeric: tabular-nums;
}
.kr-seg button.on .kr-seg-n {
  background: var(--color-brand-500, #1e88e5);
  color: #fff;
}
.kr-noresult {
  padding: 28px 12px;
  text-align: center;
  color: var(--text-tertiary, #a7a7af);
  font-size: 13px;
}

/* Detay: alanlar label-ustte/deger-altta -> okunur. Kart cercevesi artik
   .kr-detay panelinde (grup basligi alt tab'a tasindi). */
.kr-fields {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(230px, 1fr));
  gap: 16px 24px;
}
.kr-field {
  display: flex;
  flex-direction: column;
  gap: 4px;
  min-width: 0;
  padding: 3px 6px 8px;
  border-bottom: 1px solid var(--border-default, #f1f1f4);
  border-radius: 6px;
  transition: background 0.1s ease;
}
.kr-field:hover {
  background: var(--bg-secondary, #f6f7f9);
}
.kr-label {
  /* Key monospace: JSON tab'iyla gorsel bag + "ham key" sinyali (ArrivalHourTo).
     uppercase YOK -> objedeki key'le birebir, Ctrl+F ve filtre ile aranabilir.
     11px monospace okunmuyordu; 12.5px + daha koyu renk. Grid min genisligi
     bu yuzden 210 -> 230px'e cikti (uzun key'ler satir kirmasin). */
  font-family: "SFMono-Regular", Consolas, "Liberation Mono", Menlo, monospace;
  font-size: 12.5px;
  font-weight: 600;
  line-height: 1.3;
  color: var(--text-secondary, #55555f);
}
/* NOT: deger metni krCopyValue icindeki .krcv-text ile basiliyor (bu component
   .kr-value elementi uretmiyor) -> boyut/agirlik orada ayarlaniyor. */
/* Cozulmus Id adi. Degerin ALTINDA ve soluk: ham deger hangisi oldugu belirsiz
   kalmasin, ad yalnizca yardimci bilgi olsun. */
.kr-id-name {
  font-size: 11.5px;
  line-height: 1.35;
  color: var(--color-brand-600, #1565c0);
  word-break: break-word;
}
.kr-pill {
  align-self: flex-start;
  /* .krcv-text 15px oldu; bool pill'i 12px'te birakmak kucuk gosteriyordu. */
  font-size: 13px;
  font-weight: 700;
  padding: 2px 11px;
  border-radius: 20px;
}
/* Evet/Hayır bir DEGER, basari degil -> yesil yanlis anlam veriyordu
   ("AgencyConfirmRequired: Evet" iyi bir sey demek degil). Proje mavisi. */
.kr-pill.ok { background: #e8f2fd; color: #1565c0; }
.kr-pill.no {
  background: var(--bg-tertiary, #ededf1);
  /* "Hayır" okunan bir DEGER -> 3.63 yerine 5.6 kontrast */
  color: var(--text-secondary, #5a5a63);
}

/* Diziler & nesneler */
.kr-coll {
  margin-bottom: 12px;
  padding: 10px 12px;
  border: 1px solid var(--border-default, #e6e6ea);
  border-radius: 8px;
  background: var(--bg-secondary, #f8f9fb);
}
.kr-coll-head {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 6px;
}
.kr-coll-name {
  font-size: 12px;
  font-weight: 700;
  color: var(--text-primary, #23232a);
}
/* Dizi mi obje mi: krJsonTree'ye girmeden tipi gorunsun */
.kr-coll-type {
  font-family: "SFMono-Regular", Consolas, "Liberation Mono", Menlo, monospace;
  font-size: 11px;
  color: var(--text-tertiary, #a7a7af);
}
.kr-count {
  min-width: 20px;
  text-align: center;
  padding: 0 7px;
  border-radius: 20px;
  font-size: 11px;
  font-weight: 700;
  background: var(--color-brand-500, #1e88e5);
  color: #fff;
}
.kr-empty-colls {
  display: flex;
  gap: 10px;
  align-items: baseline;
  margin-top: 6px;
}
.kr-empty-list {
  font-size: 12px;
  color: var(--text-tertiary, #a7a7af);
  word-break: break-word;
}

/* LOGLAR: alt tab satiri + grid paneli */
.kr-logs-wrap {
  display: flex;
  flex-direction: column;
  flex: 1 1 auto;
  min-height: 0;
}
/* Yatay alt tab: yalniz 2 oge oldugu icin pill yeterli ve grid tum genisligi alir. */
.kr-logtabs {
  flex: 0 0 auto;
  display: flex;
  gap: 6px;
  list-style: none;
  margin: 0 0 10px;
  padding: 0;
}
.kr-logtabs li {
  display: inline-flex;
  align-items: center;
  gap: 7px;
  cursor: pointer;
  min-height: 30px;
  padding: 5px 14px;
  border: 1px solid var(--border-default, #e6e6ea);
  border-radius: 7px;
  background: var(--bg-surface, #fff);
  font-size: 12.5px;
  font-weight: 600;
  color: var(--text-secondary, #6b6b75);
  transition: background 0.12s ease, border-color 0.12s ease, color 0.12s ease;
}
.kr-logtabs li:hover:not(.active) {
  border-color: var(--color-brand-500, #1e88e5);
  color: var(--color-brand-600, #1565c0);
}
.kr-logtabs li.active {
  background: var(--color-brand-500, #1e88e5);
  border-color: var(--color-brand-500, #1e88e5);
  color: #fff;
}
.kr-logtabs li.active .kr-sub-badge {
  background: rgba(255, 255, 255, 0.24);
  color: #fff;
}
/* Log uretmeyen PMS: gizlenmez, soluklar (sebebi panelde yazili) */
.kr-logtabs li.dim {
  opacity: 0.45;
}

.kr-logs {
  flex: 1 1 auto;
  min-height: 0;
  overflow-y: auto;
  overscroll-behavior: contain;
}
/* ag-grid hucreleri dataTable (child) icinde render edilir -> scoped CSS
   ulasmaz, /deep/ sart (proje konvansiyonu). */
.kr-logs /deep/ .kr-log-badge {
  display: inline-block;
  padding: 0 9px;
  border-radius: 20px;
  font-size: 11px;
  font-weight: 700;
  line-height: 18px;
}
.kr-logs /deep/ .kr-log-badge.ok {
  background: #e6f6ee;
  color: #15703f;
}
.kr-logs /deep/ .kr-log-badge.no {
  background: #fde8e8;
  color: #c53030;
}
.kr-logs /deep/ .kr-log-link {
  font-weight: 600;
  color: var(--color-brand-600, #1565c0);
  text-decoration: underline;
}
/* Basarisiz log satiri. Zemin VE metin birlikte tanimlaniyor: yalniz birini
   vermek okunamaz satir uretir (bkz. global .ag-row.danger). */
.kr-logs /deep/ .ag-row.kr-row-fail {
  background: #fdeded;
  color: #a32020;
}
.kr-logs /deep/ .ag-row.kr-row-fail .ag-cell {
  color: #a32020;
}

/* JSON tab: "editor" paneli — header bar + satir-no gutter + kod */
.kr-json-wrap {
  border: 1px solid var(--border-default, #e3e3e8);
  border-radius: 10px;
  overflow: hidden;
  background: var(--bg-surface, #fff);
  /* Detay sekmesiyle ayni kap mantigi: bar sabit, kod alani kalan alani kaplar. */
  display: flex;
  flex-direction: column;
  flex: 1 1 auto;
  min-height: 0;
}
.krJson-bar {
  flex: 0 0 auto;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 8px 12px;
  border-bottom: 1px solid var(--border-default, #ececf1);
  background: var(--bg-secondary, #f6f7f9);
}
.krJson-meta {
  font-family: "SFMono-Regular", Consolas, "Liberation Mono", Menlo, monospace;
  font-size: 12px;
  font-weight: 600;
  color: var(--text-secondary, #6b6b75);
}
.kr-copy-btn {
  display: inline-flex;
  align-items: center;
  padding: 5px 12px;
  border-radius: 6px;
  border: 1px solid var(--border-default, #dcdce2);
  background: var(--bg-surface, #fff);
  color: var(--text-primary, #23232a);
  font-size: 12px;
  font-weight: 600;
  cursor: pointer;
  transition: background 0.12s ease, border-color 0.12s ease, color 0.12s ease;
}
.kr-copy-btn:hover {
  background: var(--bg-hover, #f2f2f5);
  border-color: var(--color-brand-500, #1e88e5);
  color: var(--color-brand-600, #1565c0);
}
/* Kaydirma kabi: gutter + kod birlikte dikey kayar; gutter yatayda sabit (sticky). */
/* TEK scroll kabi. align-items:flex-start -> cocuklar dogal (icerik) yuksekligini
   alir; stretch olsaydi kap yuksekligine sigar, gutter 171 gosterse de kod ~44'te
   kalirdi (ic ice/kirpilan scroll).
   Yukseklik artik 62vh degil: kap (.kr-json-wrap) icinde kalan alani kapliyor,
   boylece modal sabit yukseklikte kalir ve cift scrollbar olusmaz. */
.krJson-scroll {
  display: flex;
  align-items: flex-start;
  flex: 1 1 auto;
  min-height: 0;
  overflow: auto;
  background: var(--bg-surface, #fbfbfc);
}
.krJson-gutter {
  position: sticky;
  left: 0;
  z-index: 1;
  flex: 0 0 auto;
  display: flex;
  flex-direction: column;
  padding: 12px 10px;
  text-align: right;
  user-select: none;
  background: var(--bg-tertiary, #f0f1f4);
  border-right: 1px solid var(--border-default, #e6e6ec);
  font-family: "SFMono-Regular", Consolas, "Liberation Mono", Menlo, monospace;
  font-size: 12.5px;
  line-height: 1.6;
  /* Kontrast 2.06 idi (zemin #f0f1f4) -> satir numaralari neredeyse gorunmuyordu */
  color: var(--text-secondary, #70707a);
}
.krJson-gutter span {
  display: block;
}
.krJson {
  margin: 0;
  flex: 1 1 auto;
  min-width: 0;
  padding: 12px 16px;
  background: transparent;
  color: var(--text-primary, #1c1c22);
  font-size: 12.5px;
  line-height: 1.6;
  font-family: "SFMono-Regular", Consolas, "Liberation Mono", Menlo, monospace;
  white-space: pre;
  tab-size: 2;
  /* Bootstrap `pre{overflow:auto}` ic scroll'unu kes -> tek scroll .krJson-scroll'da. */
  overflow: visible;
}
.krJson .jh-key { color: #2563eb; font-weight: 600; }
.krJson .jh-str { color: #0f8a5f; }
.krJson .jh-num { color: #b4690e; }
.krJson .jh-bool { color: #7c3aed; font-weight: 600; }
.krJson .jh-null { color: var(--text-tertiary, #a0a0a8); font-style: italic; }
</style>
